'use strict';

/** Touch phones and narrow viewports skip decorative motion (iOS A2HS jitter). */
export const INSTANT_MOTION_MEDIA_QUERY = '(pointer: coarse), (max-width: 767px)';
export const INSTANT_MOTION_HTML_CLASS = 'fcp-instant-motion';

export function shouldUseInstantMotion({ coarseOrNarrow, prefersReducedMotion }) {
  return Boolean(coarseOrNarrow || prefersReducedMotion);
}
